var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 80,
    viewBox: "0 0 55 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.7 0.799997H20.555C21.325 0.799997 22.2417 0.836663 23.305 0.909995C24.3683 0.946664 25.395 1.05666 26.385 1.24C30.675 1.9 34.2683 3.385 37.165 5.695C40.0983 7.96833 42.2983 10.8283 43.765 14.275C45.2317 17.7217 45.965 21.5533 45.965 25.77C45.965 31.71 44.5167 36.825 41.62 41.115C38.76 45.3683 34.4883 48.265 28.805 49.805C27.4483 50.1717 26.1283 50.4283 24.845 50.575C23.5617 50.685 22.0767 50.74 20.39 50.74H0.7V41.445H20.225C20.9217 41.445 21.71 41.4083 22.59 41.335C23.5067 41.2617 24.3683 41.1333 25.175 40.95C27.705 40.3633 29.7583 39.3 31.335 37.76C32.9483 36.1833 34.1217 34.35 34.855 32.26C35.5883 30.1333 35.955 27.97 35.955 25.77C35.955 23.57 35.5883 21.4067 34.855 19.28C34.1217 17.1533 32.9483 15.32 31.335 13.78C29.7583 12.2033 27.705 11.14 25.175 10.59C24.3683 10.37 23.5067 10.2417 22.59 10.205C21.71 10.1317 20.9217 10.095 20.225 10.095H0.7V0.799997ZM0.7 50.74L10.93 47.55L47.615 80H33.645L0.7 50.74ZM0.92 29.675V21.81H54.215V29.675H0.92ZM19.565 8.665V0.799997H53.995V8.665H19.565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.0c07e6d482a5da1e686b050289d14d22.svg";
export { ForwardRef as ReactComponent };